package com.fireavert.tenants.server

import com.fireavert.common.Try
import com.fireavert.tenants.data_models.TenantModel

/**
 * Service to provide tenant data for units during the migration from units.tenant_* fields
 * to the separate tenants table
 */
class UnitTenantService(
    private val tenantRepository: DBTenantRepository
) {
    /**
     * Get current tenant data for a unit in the legacy format expected by UnitModel
     * Returns tenant data from tenants table if available, otherwise returns empty strings
     */
    suspend fun getTenantDataForUnit(unitId: Int): TenantData {
        return when (val result = tenantRepository.getCurrentTenantForUnit(unitId)) {
            is Try.Error -> TenantData.empty()
            is Try.Success -> {
                val tenant = result.value
                if (tenant != null) {
                    TenantData(
                        name = "${tenant.firstName} ${tenant.lastName}".trim(),
                        email = tenant.email,
                        phone = tenant.phoneOneNumber ?: ""
                    )
                } else {
                    TenantData.empty()
                }
            }
        }
    }

    /**
     * Get all tenants for a unit
     */
    suspend fun getAllTenantsForUnit(unitId: Int): List<TenantModel> {
        return when (val result = tenantRepository.getTenantsForUnit(unitId)) {
            is Try.Error -> emptyList()
            is Try.Success -> result.value
        }
    }
}

data class TenantData(
    val name: String,
    val email: String,
    val phone: String
) {
    companion object {
        fun empty() = TenantData("", "", "")
    }
}